/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames';

import { AppContext } from '../../AppContext'

import WebsiteProfile from './WebsiteProfile'
import ProcessAutomation from './ProcessAutomation'
import OciObjectStorageAdmin from './OciObjectStorageAdmin'
import RagServerConfig from './RagServerConfig';

class WebsiteAdmin extends React.Component
{
  activeTabKey = 'siteAdmin.activeTab';

  componentDidMount()
  {
    var activeTab = Number(this.context.appLocalStorage.getItem(this.activeTabKey));
    if (undefined === activeTab || null === activeTab) activeTab = 0;
    this.setState({tabIndex: activeTab});
    document.title += 'Website Admin'
  }

  constructor(props)
  {
    super();
    
    this.state =
    {
      tabIndex: 0,
    }

    this.toggleTab = this.toggleTab.bind(this);
  }

  render()
  {
    let appContext = this.context;

    return(
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 0 })}
              onClick={() => { this.toggleTab(0); }}
            >
              Website Profile
            </NavLink>
          </NavItem>
        {( window.extensionInstalled(appContext.websiteProfile.installedExtensions, this.context.extensions.Automation) &&
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 1 })}
              onClick={() => { this.toggleTab(1); }}
            >
              Process Automation
            </NavLink>
          </NavItem>
        )}
        {( window.extensionInstalled(appContext.websiteProfile.installedExtensions, this.context.extensions.OCIObjectStorage) &&
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 2 })}
              onClick={() => { this.toggleTab(2); }}
            >
              OCI Object Storage
            </NavLink>
          </NavItem>
        )}
        {window.extensionInstalled(appContext.websiteProfile.installedExtensions, this.context.extensions.AI) &&
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 3 })}
              onClick={() => { this.toggleTab(3); }}
            >
              RAG Server Config
            </NavLink>
          </NavItem>
        }
        </Nav>
        <TabContent activeTab={this.state.tabIndex}>
          <TabPane tabId={0}>
            <WebsiteProfile  tabId={0} tabIndex={this.state.tabIndex} />
          </TabPane>
        {( window.extensionInstalled(appContext.websiteProfile.installedExtensions, this.context.extensions.Automation) &&
          <TabPane tabId={1}>
            <ProcessAutomation />
          </TabPane> 
        )}
        {( window.extensionInstalled(appContext.websiteProfile.installedExtensions, this.context.extensions.OCIObjectStorage) && 2 === this.state.tabIndex &&
          <TabPane tabId={2}>
            <OciObjectStorageAdmin />
          </TabPane> 
        )}
        {( window.extensionInstalled(appContext.websiteProfile.installedExtensions, this.context.extensions.AI) && 3 === this.state.tabIndex &&
          <TabPane tabId={3}>
            <RagServerConfig />
          </TabPane> 
        )}
        </TabContent>
      </div>
    );
  }

  toggleTab(tabIndex, tab)
  {
    if (this.state.tabIndex !== tabIndex)
    {
      this.setState({ tabIndex: tabIndex });
      this.context.appLocalStorage.setItem(this.activeTabKey, tabIndex);
    } 
  }
}

WebsiteAdmin.contextType = AppContext;

export default WebsiteAdmin
